import React, { useState } from "react";
import ExtendedCheckbox from "@src/stories/elements/ExtendedCheckbox/ExtendedCheckbox";

const ExtendedProductMonogram = ({ props }) => {
  const {
    text_font_1,
    text_font_2,
    text_label_1,
    text_label_2,
    show_second,
    text_property_name = 'monogram-text',
    font_property_name = 'monogram-font',
    heading_text_1,
    description_text_1 = 'Step 2 Enter Your Monogram',
    max_characters_1 = 20,
    heading_text_2,
    description_text_2 = 'Step 3 Enter Your Monogram',
    max_characters_2 = 20,
    show_no_monogram_required_field,
    block_words
  } = props?.settings?.block_settings;

  let options = [
    {
        type: text_label_1,
        font: text_font_1
    },
    {
        type: text_label_2,
        font: text_font_2
    }
  ]

  const [ currentOption, setCurrenOption] = useState(options[0].type)
  const [ noMonogram, setnoMonogram] = useState(false)
  const [ monogram1, setMonogram1 ] = useState('');
  const [ monogram2, setMonogram2 ] = useState('');

  function filterBannedWords(text) {
    if (!block_words) return text;

    const bannedArray = block_words.split(",").map((item) => item.trim().toLowerCase());

    return text.split(" ").filter((word) => {
      return !bannedArray.some((bannedWord) =>
        word.toLowerCase().includes(bannedWord)
      );
    }).join(" ");
  }

  return (
    <div className={'product-monogram flex flex-col'}>
        <div className={`flex flex-col gap-2`}> 
            <div className={`text-[14px]`}> 
                {`Step 1 Select Font`}
            </div>

            {!noMonogram && 
              <input
                  type="text"
                  data-name={`${font_property_name}`}
                  name={`properties[${font_property_name}]`}
                  id={`line-item-${font_property_name}`}
                  value={currentOption}  
                  readOnly 
                  className="product-monogram__input line-item-property hidden"
              />
            }

            <div className="flex flex-row w-100 gap-2"> 
              {options.map((option) => (
                <div
                  key={option?.type}
                  style={{ fontFamily: option.font }}
                  className={`product-monogram__option !w-1/2 button ${option.type == currentOption ? `button-primary`: `button-secondary !font-[500]` } `}
                  onClick={()=> setCurrenOption(option.type)}
                > 
                  {option.type}
                </div>
              ))}
            </div>
        </div>

        <div className={`flex flex-col gap-4`}>
          <div className=" flex flex-col gap-2">
            {heading_text_1 &&
              <div className={`font-bold`}> 
                {heading_text_1}
              </div> 
            }

            <div className={`text-[14px]`}> 
              {description_text_1}
            </div> 

            <textarea
              data-name={`${text_property_name}-1`}
              name={`properties[${text_property_name}-1]`}
              id={`line-item-monogram-text-1`}
              placeholder="Enter your monogram"
              value={noMonogram ? "" : monogram1}
              disabled={noMonogram} 
              maxLength={max_characters_1 === 0 ?  null : max_characters_1}
              onChange={e => setMonogram1(filterBannedWords(e.target.value))}
              className={`product-monogram__input ${noMonogram ? '' : 'line-item-property'}`}
            />

            {max_characters_1 !== 0 && (
              <div className="flex justify-end text-[12px] font-[300]">
                {`${max_characters_1 - monogram1.length} Character(s) Left`}  
              </div>
            )}
          </div>

          {show_second && 
            <div className="flex flex-col gap-2">
              {heading_text_2 &&
                <div className={`font-bold`}> 
                  {heading_text_2}
                </div> 
              }

              <div className={`text-[14px]`}> 
                {description_text_2}
              </div> 

              <textarea
                data-name={`${text_property_name}-2`}
                name={`properties[${text_property_name}-2]`}
                id={`line-item-${text_property_name}-2`}
                value={noMonogram ? "" : monogram2}
                disabled={noMonogram} 
                placeholder="Enter your monogram"
                maxLength={max_characters_2 === 0 ?  null : max_characters_2}
                onChange={e => setMonogram2(filterBannedWords(e.target.value))}
                className={`product-monogram__input ${noMonogram ? '' : 'line-item-property'}`}
              />

              {max_characters_2 !== 0 && (
                <div className="flex justify-end text-[12px] font-[300]">
                  {`${max_characters_2 - monogram2.length} Character(s) Left`}  
                </div>
              )}
            </div>
          }
        </div>
  
        {show_no_monogram_required_field &&
          <div className="flex justify-center"> 
              <ExtendedCheckbox                     
                  name={'no_monogram'}
                  label={'No Monogram Required'}
                  checked={noMonogram}
                  onChange={()=> { setnoMonogram(!noMonogram); setMonogram1(''); setMonogram2(''); }}
              />
          </div>
        }
    </div>
  )
}

export default ExtendedProductMonogram;